export enum XmlTypes {
    BGM15 = 'BGM15',
    BG415W = 'BG415W'
}
